"use client";

import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "@/app/lib/hooks"; // Ensure the file paths are correct
import { clearNotification } from "@/app/lib/reducers/notificationsReducer"; // Ensure the file paths are correct
import { XMarkIcon } from "@heroicons/react/24/solid"; // Ensure Heroicons is installed

interface NotificationState {
  notification: {
    message: React.ReactNode | null;
  };
}

const Notification: React.FC = () => {
  const dispatch = useAppDispatch();
  const notification = useAppSelector(
    (state: NotificationState) => state.notification
  );

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (notification.message) {
      setVisible(true);
      const timeout = setTimeout(() => {
        setVisible(false);
        dispatch(clearNotification());
      }, 5000); // Display for 5 seconds
      return () => clearTimeout(timeout);
    }
  }, [notification.message, dispatch]);

  const handleClose = () => {
    setVisible(false);
    dispatch(clearNotification());
  };

  if (!notification.message || !visible) return null;

  return (
    <div className="fixed bottom-5 left-1/2 transform -translate-x-1/2 bg-green-500 text-white px-4 py-2 rounded shadow-lg z-50 flex items-center justify-between space-x-4">
      <span>{notification.message}</span>
      <button onClick={handleClose} className="focus:outline-none">
        <XMarkIcon className="h-5 w-5 text-white" />
      </button>
    </div>
  );
};

export default Notification;
